import {
  type ShareIntent,
  type UrlShareIntent,
  ShareIntentType,
  type TextShareIntent,
  type FileShareIntent,
  type RawShareIntent,
} from '../mobile.types';
import { isObject } from '@fabric-app/utils/guards';

export const isUrlShareIntent = (intent: ShareIntent): intent is UrlShareIntent => {
  return intent.type === ShareIntentType.URL;
};

export const isTextShareIntent = (intent: ShareIntent): intent is TextShareIntent => {
  return intent.type === ShareIntentType.TEXT;
};

export const isFileShareIntent = (intent: ShareIntent): intent is FileShareIntent => {
  return intent.type === ShareIntentType.FILE;
};

export const isRawShareIntent = (intent: unknown): intent is RawShareIntent => {
  return isObject(intent) && 'type' in intent && typeof intent.type === 'string';
};

export const isShareIntentPage = () => window.location.pathname === '/share-intent';
